import type {WordListItem} from '$lib/classes/_types/word-list-item';

export function buildJsonLd(listName: string, items: WordListItem[]) {
    return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: listName,
        numberOfItems: items.length,
        itemListElement: items.map(((word, index) => {
            return {
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@type': 'DefinedTerm',
                    name: word.word,
                    // url: `https://vocabeo.com/browse/${word.id}`,
                }
            }
        })),
    })
}